import React from "react"
import styles from "./home-page.module.scss"
import {Heading, HeadingMedium, HeadingSmall} from "../../components-shared/heading/heading"
import {InfoEmail} from "../../components-shared/info-email"

export const PrivacyPolicyPage: React.FC = () => {
  return <div className={styles.Page}>
    <Heading size="large">Privacybeleid</Heading>

    <p>In dit privacy beleid lees je alles over hoe GreenUp omgaat met jouw privacy, jouw persoonsgegevens en het gebruik van cookies.</p>

    <div>
      <HeadingSmall>Kort samengevat: jouw privacy en veiligheid staan bij GreenUp centraal</HeadingSmall>
      <ol>
        <li>Wij verkopen jouw persoonlijke gegevens nooit. Dit geldt voor al jouw gegevens waaronder: persoonlijke gegevens, transactiegegevens en financiële gegevens.</li>
        <li>GreenUp kan samengevatte inzichten verkopen aan derde partijen. Hierbij zal het echter nooit mogelijk zijn om data terug te leiden tot individuele personen.</li>
        <li>We vermelden duidelijk met welke doeleinden persoonsgegevens verwerkt worden binnen GreenUp.</li>
        <li>We vragen specifiek toestemming om persoonsgegevens te verwerken.</li>
        <li>We garanderen de hoogst mogelijke beveiligingsmaatregelen om persoonsgegevens te beschermen.</li>
        <li>Wij zullen persoonsgegevens op aanvraag ter inzage bieden, corrigeren of verwijderen</li>
      </ol>
    </div>

    <div>
      <HeadingMedium>Cookies</HeadingMedium>
      <p>GreenUp maakt gebruik van cookies. Deze zijn niet persoonlijk herleidbaar en ook niet schadelijk voor je device. Cookies zijn nodig voor het optimaal functioneren van de website van GreenUp zoals bijvoorbeeld het kunnen opslaan dat je ingelogd bent. GreenUp werkt niet met advertenties en zeker niet op basis van jouw financiële data.</p>
    </div>


    <div>
      <HeadingSmall>Gebruik van cookies</HeadingSmall>
      <p>GreenUp gebruikt cookies om kennis op te doen over hoe de website gebruikt wordt en om fouten op te sporen. Hiervoor gebruiken we Google Analytics en Hotjar.</p>
    </div>

    <div>
      <HeadingSmall>Hoe lang blijven cookies staan?</HeadingSmall>
      <p>Sommige cookies verdwijnen als je je browser sluit. Andere cookies blijven enkele dagen tot jaren staan. Je kan cookies altijd op elk moment via je browser verwijderen.</p>
    </div>

    <div>
      <HeadingMedium>Privacy</HeadingMedium>
      <p>GreenUp stelt jouw privacy altijd voorop. Je wordt onder andere geïnformeerd over de persoonsgegevens die GreenUp verwerkt, voor welke doeleinden deze worden verwerkt en welke rechten je hebt.</p>
      <p>GreenUp zorgt er onder andere voor dat:</p>
      <ol>
        <li>Wij altijd duidelijk vermelden met welke doeleinden wij persoonsgegevens verwerken;</li>
        <li>Wij onze verzameling van persoonsgegevens beperken tot alleen de persoonsgegevens die nodig zijn voor de genoemde en geaccordeerde doeleinden;</li>
        <li>Wij altijd vragen om uitdrukkelijke toestemming om uw persoonsgegevens te verwerken in gevallen waarin uw toestemming is vereist;</li>
        <li>Wij passende beveiligingsmaatregelen nemen om uw persoonsgegevens te beschermen en dat ook eisen van partijen die in onze opdracht persoonsgegevens verwerken;</li>
        <li>Wij uw recht respecteren om ten alle tijden uw persoonsgegevens op uw aanvraag ter inzage te bieden, te corrigeren of te verwijderen.</li>
      </ol>
    </div>

    <div>
      <HeadingSmall>Van wie worden er persoonsgegevens verwerkt?</HeadingSmall>
      <p>GreenUp verwerkt persoonsgegevens van gebruikers van GreenUp.</p>
    </div>

    <div>
      <HeadingSmall>Voor welke doelen worden welke persoonsgegevens verwerkt?</HeadingSmall>
      <ol>
        <li>Het aanmaken van een account</li>
        <li>Het bieden van een overzicht in de financiële situatie</li>
        <li>Het bieden van een overzicht in de ecologische impact</li>
      </ol>
    </div>

    <div>
      <HeadingSmall>Opslag van persoonsgegevens</HeadingSmall>
      <p>GreenUp verwerkt persoonsgegevens op basis van door jou gegeven toestemming. Je kan je gegeven toestemming te allen tijde intrekken. GreenUp bewaart jouw persoonsgegevens nooit langer dan noodzakelijk is voor het bereiken van de eerder genoemde doelen. Wanneer jij je account verwijdert, zal GreenUp automatisch alle data en persoonsgegevens verwijderen.</p>
    </div>

    <div>
      <HeadingSmall>Bijzondere categorieën van persoonsgegevens en persoonsgegevens van strafrechtelijke aard</HeadingSmall>
      <p>GreenUp verkrijgt uitdrukkelijke toestemming voor de verwerking van persoonsgegevens voor een welbepaald doeleinde. Dit doeleinde is een overzicht bieden van de financiële en ecologische situatie. Binnen de AVG wetgeving wordt er onderscheid gemaakt tussen verschillende categorieën persoonsgegevens. Bijzondere categorieën van persoonsgegevens en persoonsgegevens van strafrechtelijke aard nemen binnen deze wetgeving een belangrijke positie in. De volgende persoonsgegevens vallen binnen deze categorieën:</p>
      <ul>
        <li>persoonsgegevens waaruit politieke opvattingen blijken;</li>
        <li>persoonsgegevens waaruit religieuze of levensbeschouwelijke overtuigingen blijken;</li>
        <li>persoonsgegevens waaruit het lidmaatschap van een vakvereniging blijkt;</li>
        <li>betalingsgegevens waaruit blijkt dat een boete betaald moet worden;</li>
        <li>gegevens over iemands gezondheid;</li>
        <li>gegevens over iemands seksueel gedrag of seksuele gerichtheid;</li>
        <li>persoonsgegevens waaruit ras of etnische afkomst blijkt;</li>
        <li>genetische gegevens; en</li>
        <li>biometrische gegevens met het oog op de unieke identificatie van een persoon.</li>
      </ul>
      <p>Het is mogelijk dat transactiegegevens bijzondere persoonsgegevens of persoonsgegevens van strafrechtelijke aard bevatten, wanneer dit kan worden afgeleid uit de wederpartij of de omschrijving bij de betaling. Denk hierbij aan een betaling voor een lidmaatschap van een politieke partij of werknemersvakbond of een gift aan een kerkelijke instantie. Daarnaast zouden eventuele administratieve sancties als boetes ook zichtbaar kunnen zijn in de transactiegegevens.</p>
      <p>De activiteiten van GreenUp zijn niet gericht op het verwerken van bijzondere of strafrechtelijke persoonsgegevens. Het valt echter niet uit te sluiten dat zulke gegevens zich kunnen bevinden tussen de gegevens die GreenUp ontvangt.</p>
    </div>

    <div>
      <HeadingSmall>Gegevens delen met derden</HeadingSmall>
      <p>GreenUp zal uw persoonlijke gegevens nooit verkopen of misbruiken. GreenUp maakt gebruik van technologieën om gegevens te verzamelen om onze diensten te verbeteren, zoals Hotjar en Google Analytics.</p>
    </div>

    <div>
      <HeadingSmall>Het verbeteren van onze diensten en product</HeadingSmall>
      <p>We verzamelen uitsluitend eventgegevens om onze service te verbeteren. Daartoe verzamelen we automatisch informatie van uw browser of apparaat wanneer u onze service gebruikt. Deze informatie kan uw IP-adres, apparaat-ID en -type, uw browsertype en taal, het besturingssysteem dat door uw apparaat wordt gebruikt, toegangstijden en het verwijzende websiteadres omvatten. Dit maakt het mogelijk om uw gebruikerservaring aan te passen en te verbeteren op zowel ons web- als app-platform.</p>
      <p>We integreren zogeheten pixeltags (ook wel webbakens of clear GIF's genoemd) op webpagina's en e-mails. Deze kleine, onzichtbare afbeeldingen worden gebruikt om toegang te krijgen tot cookies en gebruikersactiviteiten bij te houden (zoals hoe vaak een pagina wordt bekeken). Met deze technologie kunnen we leren welke blogs en pagina's het populairst zijn, zodat we meer van deze relevante content kunnen genereren. We gebruiken het ook om te bepalen welke e-mailberichten het meest worden gewaardeerd door onze gebruikers.</p>
      <p>Wanneer u de GreenUp-applicatie gebruikt, gebruiken we naast cookies ook mobiele apparaat-ID's (de unieke ID die door de fabrikant aan een apparaat is toegewezen) om u te herkennen. In tegenstelling tot cookies kunnen apparaat-ID's niet worden verwijderd. Analytics-bedrijven gebruiken apparaat-ID's om informatie over app-gebruik bij te houden. Platforms waarmee we deze gegevens kunnen kunnen delen, zijn onder meer Hotjar en Microsoft. Hierdoor kunnen we uw voorkeuren opslaan en uw gebruik van onze app volgen. We gebruiken deze gegevens om te bepalen welke functionaliteiten binnen onze applicatie het meest worden gebruikt. Vervolgens proberen we functies te ontwikkelen die vergelijkbaar zijn.</p>
    </div>

    <div>
      <HeadingMedium>Jouw rechten</HeadingMedium>
      <p>Er is een aantal rechten die jou toekomen:</p>
    </div>

    <div>
      <HeadingSmall>Recht op inzage, correctie, verwijdering</HeadingSmall>
      <p>Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of verwijderen.</p>
    </div>

    <div>
      <HeadingSmall>Recht om vergeten te worden</HeadingSmall>
      <p>In een aantal gevallen heb je het recht om vergeten te worden. GreenUp zal dan jouw persoonsgegevens wissen én eventuele derden aan wie persoonsgegevens zijn verstrekt vragen dit ook te doen.</p>
    </div>

    <div>
      <HeadingSmall>Recht op verzet</HeadingSmall>
      <p>In bepaalde gevallen heb je het recht om je te verzetten tegen de verwerking van jouw persoonsgegevens. GreenUp zal jouw persoonsgegevens niet langer verwerken wanneer je het recht op verzet inroept.</p>
    </div>

    <div>
      <HeadingSmall>Recht op dataportabiliteit</HeadingSmall>
      <p>Je hebt het recht om jouw persoonsgegevens over te kunnen dragen aan bijvoorbeeld andere diensten. Wanneer je hierom verzoekt zal GreenUp jouw digitale gegevens in een overdraagbare en leesbare vorm aan je verstrekken.</p>
    </div>

    <div>
      <HeadingSmall>Toestemming intrekken</HeadingSmall>
      <p>Wanneer je toestemming hebt gegeven voor de verwerking van jouw persoonsgegevens, kan je de door jou gegeven toestemming te allen tijde intrekken. Let er wel op dat het intrekken van jouw toestemming geen terugwerkende kracht heeft.</p>
      <p>Als je een verzoek wil indienen met betrekking tot bovenstaande rechten, kan je een mail sturen naar info@gogreenup.nl. Vermeld in de mail wat jouw verzoek precies is en, indien mogelijk, om welke persoonsgegevens het gaat.</p>
      <p>GreenUp zal een verzoek binnen één maand behandelen. Wanneer het gaat om een complex verzoek kunnen hier echter maximaal twee maanden extra voor genomen worden. Mocht dit het geval zijn dan word je hierover wel binnen één maand geïnformeerd.</p>
    </div>

    <div>
      <HeadingMedium>Contact</HeadingMedium>
      <p><InfoEmail/></p>
    </div>

    <div>
      <HeadingMedium>Klachten</HeadingMedium>
      <p>In het geval van een klacht kan er contact op worden genomen via <InfoEmail/>. Bij klachten kan ook contact opgenomen worden met de Autoriteit Persoonsgegevens.</p>
    </div>

    <div>
      <HeadingMedium>Wijzigingen in dit Privacy beleid</HeadingMedium>
      <p>GreenUp behoudt zich het recht voor het Privacy beleid te wijzigen wanneer er interne of externe ontwikkelingen zijn. De meest recente versie kan altijd gevonden worden op de website van GreenUp. Gebruikers zullen altijd een notificatie krijgen wanneer dit Privacy beleid gewijzigd wordt.</p>
    </div>

  </div>
}